import React, { useState, useEffect, useRef } from 'react'
import { Modal, Button, Table } from 'react-bootstrap'
import { getBaseURL } from '../../../../GlobalComponents/URLs'
import { FiExternalLink } from 'react-icons/fi'

const AssemblyIDSelection = ({
    handleAssemblyIDSelection,
    UID,
    aWCAssemblyUIDList,
    handleAssemblyIdChange,
    handleCreateNewUidClick,
    disabled,
    isNewAssembly,
    showAssemblyListModal,
    setShowAssemblyListModal
}) => {

    const divContainer = useRef(null)

    const handleClose = () => setShowAssemblyListModal(false)

    const handleOpen = () => setShowAssemblyListModal(true)

    const handleResultClick = (e) => {
        let u = parseInt(e.target.parentNode.children[0].innerText)
        handleAssemblyIdChange(u)
        setShowAssemblyListModal(false)
    }

    return (
        <div className='tag-uid-search'>
            <>
                <input
                    className='validation-dummy'
                    style={{ width: '20px' }}
                    onKeyPress={(e) => e.preventDefault()}
                ></input>
                <div ref={divContainer}>
                    {UID > 0 && UID !== null && (
                        <>
                            <span style={{ marginRight: 10 }}>{UID}</span>
                            {!isNewAssembly && (
                                <span
                                    className='glyphicon glyphicon-pencil'
                                    onClick={disabled ? () => null : handleOpen}
                                    style={{ cursor: 'pointer' }}
                                ></span>
                            )}
                        </>
                    )}
                    {(UID <= 0 || UID === null) && (
                        <>
                            {!isNewAssembly && (
                                <span
                                    className='glyphicon glyphicon-search'
                                    onClick={
                                        disabled ? () => null : () => handleAssemblyIDSelection()
                                    }
                                    style={{ cursor: 'pointer' }}
                                >
                                    {/* {props.disabled ? '  Locked' : ''} */}
                                </span>
                            )}
                        </>
                    )}
                    <Modal
                        show={showAssemblyListModal}
                        dialogClassName='tag-uid-search-modal-dialog'
                        backdropClassName='veil'
                        animation={false}
                        centered
                        autoFocus={false}
                        onHide={handleClose}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title style={{ display: 'inline-block' }}>
                                Previously Used AWC IDs
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {aWCAssemblyUIDList?.length > 0 && (
                                <Table striped bordered hover size='sm'>
                                    <thead>
                                        <tr>
                                            <th>AWC ID</th>
                                            <th>Serial Number</th>
                                            <th>Sales Order Number</th>
                                            <th>Sales Order Date</th>
                                            <th>AWC ID Created</th>
                                            <th>Form Link</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {aWCAssemblyUIDList.map((result) => {
                                            const isHighlighted = result.AWCAssemblyID === UID
                                            const formLink = result.FormLink?.trim()
                                            return (
                                                <tr
                                                    key={result.AWCAssemblyID}
                                                    className='trResult'
                                                    style={{
                                                        backgroundColor: isHighlighted
                                                            ? '#ffeb3b'
                                                            : 'transparent',
                                                    }}
                                                >
                                                    <td onClick={handleResultClick}>
                                                        {result.AWCAssemblyID}
                                                    </td>
                                                    <td onClick={handleResultClick}>
                                                        {result.SerialNumber?.trim()}
                                                    </td>
                                                    <td onClick={handleResultClick}>
                                                        {result.SalesOrderNumber?.trim()}
                                                    </td>
                                                    <td onClick={handleResultClick}>
                                                        {new Date(
                                                            result.SalesOrderDate
                                                        ).toLocaleDateString('en-US')}
                                                    </td>
                                                    <td onClick={handleResultClick}>
                                                        {new Date(
                                                            result.AWCAssemblyIDCreated
                                                        ).toLocaleDateString('en-US')}
                                                    </td>
                                                    <td style={{ textAlign: 'center' }}>
                                                        {formLink ? (
                                                            <a
                                                                href={`${getBaseURL()}${formLink}`}
                                                                target='_blank'
                                                                rel='noopener noreferrer'
                                                            >
                                                                <FiExternalLink />
                                                            </a>
                                                        ) : (
                                                            '' // Render an empty string if formLink is empty
                                                        )}
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </Table>
                            )}
                            {aWCAssemblyUIDList?.length === 0 && (
                                <div className='noResults'>
                                    No matching tag or serial number found.
                                </div>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <form id='formUid'>
                                <div style={{ float: 'right' }}>
                                    <Button
                                        variant='primary'
                                        size='sm'
                                        style={{ float: 'right' }}
                                        onClick={() => {
                                            handleCreateNewUidClick()
                                            setShowAssemblyListModal(false)
                                        }}
                                    >
                                        Create New AWC ID
                                    </Button>
                                </div>
                            </form>
                        </Modal.Footer>
                    </Modal>
                </div>
            </>
        </div>
    )
}

export default AssemblyIDSelection
